export default __webpack_public_path__ + "static/media/banner-bg.f03d93f9.png";